"use strict";

exports.__esModule = true;
exports.default = void 0;
var Swipe = /*#__PURE__*/function () {
  function Swipe(onUpdate, onRelease) {
    var _this = this;
    this.touch = null;
    this.lastX = 0;
    this.currentX = 0;
    this.onUpdate = null;
    this.onRelease = null;
    this.onTouchStart = function (_ref) {
      var touches = _ref.touches;
      if (_this.touch === null) {
        var touch = touches[0];
        _this.currentX = touch.clientX;
        _this.lastX = _this.currentX;
        _this.touch = touch.identifier;
      }
    };
    this.onTouchEnd = function (_ref2) {
      var touches = _ref2.changedTouches;
      if (_this.findTouch(touches)) {
        _this.touch = null;
        if (_this.onRelease) {
          _this.onRelease();
        }
        if (_this.onUpdate) {
          _this.onUpdate();
        }
      }
    };
    this.onTouchMove = function (_ref3) {
      var touches = _ref3.touches;
      var touch = _this.findTouch(touches);
      if (touch) {
        _this.currentX = touch.clientX;
        if (_this.onUpdate) {
          _this.onUpdate();
        }
      }
    };
    this.onUpdate = onUpdate;
    this.onRelease = onRelease;
  }
  var _proto = Swipe.prototype;
  _proto.findTouch = function findTouch(touches) {
    var _this2 = this;
    return Array.prototype.find.call(touches, function (_ref4) {
      var identifier = _ref4.identifier;
      return identifier === _this2.touch;
    });
  };
  _proto.getDeltaX = function getDeltaX() {
    return this.currentX - this.lastX;
  };
  _proto.reset = function reset() {
    this.lastX = this.currentX;
  };
  return Swipe;
}();
var _default = exports.default = Swipe;